import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { canViewAssetLabels, isUserAllowedToAccess, PERMISSION_NAMES } from '../../utils/AuthUtils';
import { withUserType } from '../withUserType';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { AssetsAddLabelButton, LabelEntityType } from '../LabelSystem';
import LabelChip from '../StarLabels/LabelChip';

const AssetDetailLabels: React.FC<any> = ({
	asset,
	onSave,
	className = 'mb-6',
	userType,
	companyConfig,
	currentUser,
}) => {
	const roles = nullSafeGetOrElse('roles', currentUser, []);
	const canViewLabels = useMemo(
		() => canViewAssetLabels(userType, companyConfig, currentUser),
		[userType, companyConfig, currentUser]
	);
	const canApplyLabels = useMemo(
		() =>
			isUserAllowedToAccess(userType)(PERMISSION_NAMES.APPLY_ASSET_LABELS, companyConfig, roles),
		[userType, companyConfig, roles]
	);

	const labels = nullSafeGetOrElse('assetLabels', asset, []);
	const assetId = nullSafeGetOrElse('id', asset, null);

	if (!assetId || !canViewLabels) return null;
	if (labels.length === 0 && !canApplyLabels) return null;

	return (
		<div className={`flex flex-row flex-wrap items-center gap-3 ${className}`}>
			{labels.map((label) => (
				<LabelChip label={label} key={label.id} />
			))}
			<AccessPermissionChecker name={PERMISSION_NAMES.APPLY_ASSET_LABELS}>
				<AssetsAddLabelButton
					entityType={LabelEntityType.ASSET}
					entityId={assetId}
					existingLabels={labels}
					variant="hollowOnDark"
					onSave={onSave}
				/>
			</AccessPermissionChecker>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
	currentUser: state.session.currentUser,
});

export default withUserType(connect(mapStateToProps)(AssetDetailLabels));
